import { useEffect, useReducer, useState } from "react";
import { enumUtil } from "../../../utils/Enum";
import AddNewPrompt from "../../Setup/Services/Prompts/AddNewPrompt";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import NotificationHandler from "../../../utils/NotificationHandler";
import isNull from "../../../utils/NullChecking";
import GridColumnHeader from "../../Setup/Shared/GridColumnHeader";
import Table from "../../Setup/Shared/Table";
import SearchHeader from "../../Setup/Shared/SearchHeader";
import Loader from "../../shared/Loader/Loader";
import usePagination from "../../../customhooks/usePagination";
import { connect } from "react-redux";
import AddNewAITranscript from "./AddNewAITranscript";
import ViewTestResults from "./ViewTestResults";
import handleCopyText from "../../shared/CopyData";

const AIPrompts = (props) => {
    const { type, Settings } = { ...props };
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);
    const API_URL_General = enumUtil.controller.AINoteWorkflows
    const API_URL_AITool = enumUtil.controller.AITool
    const [is, setIs] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    const [totalCounts, setTotalCounts] = useState(false)
    const [starPromptsData, setStarPromptsData] = useState([]);
    const [searchParam, setSearchParam] = useState("");
    const [isClose, setIsClose] = useState();
    // add new prompt popup
    const [isOpenNewPrompt, setIsOpenNewPrompt] = useState(false)
    const [promptID, setPromptID] = useState(null)
    const handleOpenNewPrompt = (row) => {
        setIsOpenNewPrompt(true)
        setPromptID(row.AIPromptDefinitionsID)
    }
    const handleCloseNewPrompt = () => {
        setIsOpenNewPrompt(false)
        setPromptID(null)
    }
    const DeletePrompt = () => {
        setIsOpenNewPrompt(false)
        setIsClose((Math.random()));
    }
    let promptPopup
    if (isOpenNewPrompt) {
        promptPopup = <AddNewAITranscript isOpenNewPrompt={isOpenNewPrompt} handleClose={handleCloseNewPrompt} promptID={promptID} onDeletePrompt={DeletePrompt} />
    }
    const flattenPrompt = (text) => {
        return text.replace(/\\n/g, '\n');
    };
    const [copiedText, setCopiedText] = useState({});
    const handleCopy = (row, type) => {
        // let name = `${row}-${type}`;
        handleCopyText(type);
        setCopiedText({ ...copiedText, [row]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [row]: false });
        }, 300)
    }
    const columns = [
        {
            key: 'Transcript',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Transcript'} sortIcon={true} type={'string'} colKey={'Transcript'} data={starPromptsData} setData={setStarPromptsData} />),
            resizable: true,
            width: 400,
            renderCell: ({ row }) => {
                return (
                    <div className="align-items-center copy_icon pri_ins copy_icon_hover d-flex gap-1 justify-content-between w-100">
                        <div className="min-w-0">
                            <p className="text validation_message text-nowrap" title={flattenPrompt(row.Transcript)}>
                                {/* {row.Transcript} */}
                                {flattenPrompt(row.Transcript)}
                            </p>
                        </div>
                        {row.Transcript && (
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.AIToolRequestsID, row.Transcript)} ></i>
                                <p className="tool_tip xsm_text text-light">Copy</p>
                            </div>
                        )}
                        {copiedText[`${row.AIToolRequestsID}`] ? (
                            <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p>
                        ) : (
                            <></>
                        )}
                    </div>
                )
            }
        },
        {
            key: 'NoteType',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'Note Type'} sortIcon={true} type={'string'} colKey={'NoteType'} data={starPromptsData} setData={setStarPromptsData} />),
            resizable: true,
        },
        // {
        //     key: 'PromptName',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Category'} sortIcon={true} type={'string'} colKey={'PromptName'} data={starPromptsData} setData={setStarPromptsData} />),
        //     resizable: true,
        // },
        // {
        //     key: 'Description',
        //     name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
        //         iconName={'icon-card'} headerName={'Description'} sortIcon={true} type={'string'} colKey={'Description'} data={starPromptsData} setData={setStarPromptsData} />),
        //     resizable: true,
        //     width: 400,
        //     renderCell: ({ row }) => {
        //         return (
        //             <div className="text validation_message text-nowrap" title={row.Description}>
        //                 {row.Description}
        //             </div>
        //         )
        //     }
        // },
        {
            key: 'UpdatedBy',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Entry By'} sortIcon={true} type={'string'} colKey={'UpdatedBy'} data={starPromptsData} setData={setStarPromptsData} />),
            resizable: true,
        },
        {
            key: 'UpdatedDate',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                headerName={'Entry Date'} sortIcon={true} type={'string'} colKey={'UpdatedDate'} data={starPromptsData} setData={setStarPromptsData} />),
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            {row.UpdatedDate}
                        </div>
                    </>
                );
            }
        },
        {
            key: 'Action',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Action'} sortIcon={false} type={'string'} colKey={'Action'} data={starPromptsData} setData={setStarPromptsData} />),
            resizable: true,
            width: 85,
            renderCell: ({ row }) => {
                return (
                    <button className='btn btn-link p-0' onClick={() => handleViewResult(row)}> View Result</button>
                )
            }
        },
    ];
    const LoadData = (param) => {
        const SearchPageNo = !param;
        setIsLoading(true)
        ServerRequestProtected(API_URL_AITool + "/AIToolGrid", 'post', {
            "TableName": enumUtil.enumAPITableName.AIToolRequests,
            "SearchParam": param ? param : '',
            // "SearchCriteria": {
            //     "Search": param ? param : ''
            // },
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            setStarPromptsData(response.Rows)
            handleGridHeader({ defaultData: response.Rows })
            setTotalPages(response.count.NumOfPages);
        }).catch((error) => {
            setStarPromptsData([])
            setTotalCounts(0)
            setIsLoading(false)
        })
    }
    useEffect(() => {
        LoadData()
    }, [PerPage, PageNo, isClose]);

    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam()
        }
    }
    const SearchByParam = () => {
        LoadData(searchParam)
    }

    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: false,
        masterListButton: false
    }
    const [isViewResult, setIsViewResult] = useState(false)
    const [resultID, setResultID] = useState(null)
    const [otherData, setOtherData] = useState({
        Transcript: '',
        NoteType: ''
    })
    const handleViewResult = (row) => {
        setIsViewResult(true)
        setResultID(row.AIToolRequestsID + "")
        setOtherData({
            Transcript: row.Transcript,
            NoteType: row.NoteType,
        })
    }
    const onCloseViewResult = () => {
        setIsViewResult(false)
        setOtherData({
            Transcript: '',
            NoteType: ''
        })
        setResultID(null)
    }
    let viewResultPopup
    if (isViewResult) {
        viewResultPopup = <ViewTestResults isViewResult={isViewResult} onClose={onCloseViewResult} id={resultID} otherData={otherData} />
    }
    return (
        <div className="row hk-opt-bar m-0 g-0">
            {promptPopup}
            {viewResultPopup}
            <div className="d-flex w-100">
                <p className="md_text fs-14 font-sb w-100">AI Tool
                </p>
            </div>
            {isLoading ? <Loader /> : null}
            <div className='container-fluid action-row br-clr'>
                <div className="row justify-content-between">
                    <div className="col-4 ps-0">
                        <div className="input">
                            <div className='input-group hk-input-search'>
                                <input type="text" className='form-control fc-xs'
                                    placeholder='Search by note'
                                    onChange={e => setSearchParam(e.target.value)}
                                    onKeyDown={SearchOnEnter}
                                />
                                <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                    <i className="bi bi-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-2 ps-0 d-flex align-items-center justify-content-end gap-2 no-search-margin" onClick={handleViewResult}>
                        view result
                    </div> */}
                    <div className="col-6 ps-0 d-flex align-items-center justify-content-end gap-2 no-search-margin">
                        {/* <SearchHeader
                            AddNew={handleOpenNewPrompt}
                            Key={'001'}
                            Name={'Star Prompts'}
                            Counts={totalCounts}
                        /> */}
                        <SearchHeader
                            AddNew={handleOpenNewPrompt}
                            Key={'001'}
                            Name={'Star Prompts'}
                            searchButton={searchButton}
                        />
                    </div>
                </div>
            </div>
            <Table
                columns={columns}
                rows={starPromptsData}
                dynamicClass='fill-grid DataGrid-Table hk-exp-table Ai-prompt-grid'
                rowHeight={25}
                PerPage={PerPage}
                PageNo={PageNo}
                TotalPages={TotalPages}
                handlePageClick={handlePageClick}
                PreviousPage={PreviousPage}
                handleFingByCreteria={handleFingByCreteria}
                NextPage={NextPage}
                Key={'ehrSettings'}
                Name={'Star Prompts'}
                TableName={'AIToolRequests'}
                handleSelectData={handleSelectData}
                hideColClass={'hide'}
            />
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(AIPrompts);